import React, { useContext, useEffect, useState } from "react";
import { ChromePicker } from "react-color";
import AppContext from "../../../context/store";
import AuthContainer from "../../../components/AuthContainer";
import CardSection from "../../../components/Cards/CardSection";

import BetweenTimeGenerator from "../../../functions/BetweenTimeGenerator";

import styled from "styled-components";
import { Column, Grid } from "../../../theme/Grid";
import Input from "../../../theme/CustomMUI/Input";
import Select from "../../../theme/CustomMUI/Select";
import Button from "../../../theme/Button";
import MaskedInput from "../../../theme/CustomMUI/MaskedInput";
import Axios from "axios";
import {
  ButtonBase,
  FormControlLabel,
  Switch,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import WarningIcon from '@material-ui/icons/Warning';
import { toast } from "react-toastify";
import ModalDialog from "../../../theme/CustomMUI/AlertDialog";
import { Alert } from "@material-ui/lab";
import Validate from "../../../functions/Validate";

import FormDataGenerator from "../../../functions/FormDataGenerator";
import CompressImage from "../../../functions/CompressImage";
import FCLabel from "../../../theme/FCLabel";
import CSwitch from "../../../theme/CustomMUI/CSwitch";
import LimitedPermission from "../../../functions/LimitedPermissions";
import { flushSync } from "react-dom";
import { CloseOutlined } from "@material-ui/icons";
import EmpoolesPackages from "../../../components/EmpoolesPackages";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";

const SelectAllButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  padding: 0 8px;
  font-size: 13px;
  color: #3189ec;
  background: rgba(49, 137, 236, 0.1);
  border-radius: 4px;
  cursor: pointer;
  margin-right: 5px;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover {
    background: rgba(49, 137, 236, 0.2);
  }
`;

const SingleEmployee = () => {
  const context = useContext(AppContext);
  const params = useParams();
  const history = useHistory();

  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [forceDeleteConfirm, setForceDeleteConfirm] = useState(false);
  const [forceDeleteMessage, setForceDeleteMessage] = useState("");
  const [packets, setPackets] = useState([]);

  const [selectedDay, setSelectedDay] = useState(1);
  const [loaded, setLoaded] = useState(false);
  const [week, setWeek] = useState([
    "Pazartesi",
    "Salı",
    "Çarşamba",
    "Perşembe",
    "Cuma",
    "Cumartesi",
    "Pazar",
  ]);

  const [generatedHours, setGeneratedHours] = useState(
    BetweenTimeGenerator({
      ...context.state.company_shift,
    })
  );

  const [categories, setCategories] = useState([]);

  const [companyServices, setCompanyServices] = useState([]);

  const [categoryId, setCategoryId] = useState(0);
  const [categoryOpen, setCategoryOpen] = useState([
    {
      id: 0,
      inAcvtive: false,
    },
  ]);

  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const [originalNationalId, setOriginalNationalId] = useState(null);

  const [employee, setEmployee] = useState({
    color: "",
    id: null,
    name: null,
    surname: null,
    sex: null,
    password: null,
    send_sms: null,
    show_at_url: null,
    national_id: null,
    package_ids: [],
    detail: {
      profile_photo: null,
      job_title: null,
      bounty: null,
      phone: null,
      mail: null,
      national_id: null,
      // birthday: null,
      // format_birthday: null,
    },
    limited_perm: {
      id: null,
      appointment: 2,
      sales: 2,
      packet: 2,
      stock: 2,
      customer: 2,
      appointment_visibility: 1,
      customer_info: 2,
      services: 2,
      sms: 2,
      income_expense: 2,
      accounting: 2,
      wallet: 2,
      gallery: 2,
      system: 2,
    },
    permission: 0,
    service_ids: [],

    closed_appointments: {
      1: { active: true, hours: [] },
      2: { active: true, hours: [] },
      3: { active: true, hours: [] },
      4: { active: true, hours: [] },
      5: { active: true, hours: [] },
      6: { active: true, hours: [] },
      7: { active: true, hours: [] },
    },
    file: null,
  });

  const [limitedPermission, setLimitedPermission] = useState([
    ...LimitedPermission(),
  ]);
  const [selectedAgainServiceModal, setSelectedAgainServiceModal] =
    useState(false);
  const [selectedAgainServiceList, setSelectedAgainServiceList] = useState([]);
  const [lastServicesIds, setLastServicesIds] = useState([]);

  const [employeeServices, setEmployeeServices] = useState([]);

  const getRequiredArraysForStaffInsert = () => {
    Axios.get(`${context.api_endpoint}/company/itself`)
      .then(({ data }) => {
        setGeneratedHours([
          ...BetweenTimeGenerator({
            ...data.data.hours,
          }),
        ]);
      })
      .catch((e) => {
        try {
          const errorMessage = e?.response?.data?.data
            || e?.response?.data?.message
            || e?.message
            || "Şirket bilgileri yüklenirken bir hata oluştu";
          toast.error(errorMessage);
        } catch (error) {
          console.error("Toast error:", error);
          toast.error("Bir hata oluştu");
        }
      });
  };

  const getSingleStaff = () => {
    Axios.post(`${context.api_endpoint}/company/staff/bounty`, {
      staff_id: parseInt(params.id),
    });

    Axios.get(`${context.api_endpoint}/company/staff/${params.id}`)
      .then(({ data: { data } }) => {
        flushSync(() => {
          setLoaded(true);
          setPackets([...data?.staff_packets.map((m) => m.packet_id)]);
          setCompanyServices([
            ...data.company_services.map((service, i) => {
              if (
                service.category_name &&
                service.category_name.toLowerCase()?.includes("erkek")
              ) {
                service.name += " (E)";
              } else if (
                service.category_name &&
                service.category_name.toLowerCase()?.includes("kadın")
              ) {
                service.name += " (K)";
              }
              return service;
            }),
          ]);
          setEmployeeServices([...data.services]);
          setLastServicesIds(
            [...data.services].map((s) => s.service && s.service.id)
          );
          setOriginalNationalId(data.detail?.national_id ?? null);
          setEmployee({
            ...data,
            name: data.name,
            surname: data.surname,
            color: data.color,
            national_id: data.detail?.national_id ?? null,
            // closed_appointments: undefined,
            service_ids: [...data.services].map(
              (s) => s.service && s.service.id
            ),
            closed_appointments:
              data.closed_appointments.un_appointments &&
                data.closed_appointments.un_appointments !== ""
                ? JSON.parse(data.closed_appointments.un_appointments)
                : {
                  1: { active: true, hours: [] },
                  2: { active: true, hours: [] },
                  3: { active: true, hours: [] },
                  4: { active: true, hours: [] },
                  5: { active: true, hours: [] },
                  6: { active: true, hours: [] },
                  7: { active: true, hours: [] },
                },
            detail: {
              ...data.detail,
              // birthday: moment(data.data.detail.birthday).format("DD/MM/YYYY"),
              // format_birthday:
              //   data.data.detail.birthday !== null
              //     ? new Date(
              //         moment(data.data.detail.birthday).format("YYYY-MM-DD")
              //       )
              //     : null,
            },
          });
        });
        if (data.limited_perm === null) {
          setEmployee((prevEmployee) => ({
            ...prevEmployee,
            limited_perm: {
              id: null,
              appointment: 2,
              sales: 2,
              packet: 2,
              stock: 2,
              customer: 2,
              customer_info: 2,
              services: 2,
              sms: 2,
              income_expense: 2,
              accounting: 2,
              wallet: 2,
              gallery: 2,
              system: 2,
            },
          }));
        }
      })
      .catch((e) => {
        try {
          const errorMessage = e?.response?.data?.data
            || e?.response?.data?.message
            || e?.message
            || "Personel bilgileri yüklenirken bir hata oluştu";
          toast.error(errorMessage);
        } catch (error) {
          console.error("Toast error:", error);
          toast.error("Bir hata oluştu");
        }
      });
  };
  // update_packets
  const updateState = (newStateValue) => {
    setPackets(newStateValue);
  };

  const uploadPhotoSingleStaff = async (e) => {
    Axios.post(
      `${context.api_endpoint}/company/staff/update/${params.id}/photo`,
      FormDataGenerator({
        file: await CompressImage(e.target.files[0], {
          maxSizeMB: 2,
          fileType: "image/jpg",
        }),
      }),
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then((response) => {
        if (response.status === 201) {
          toast.success(context.t(`profile.photoUploadToast`));
          getSingleStaff();
        }
      })
      .catch((e) => {
        try {
          const errorMessage = e?.response?.data?.data
            || e?.response?.data?.message
            || e?.message
            || "Fotoğraf yüklenirken bir hata oluştu";
          toast.error(errorMessage);
        } catch (error) {
          console.error("Toast error:", error);
          toast.error("Bir hata oluştu");
        }
      });
  };

  const deletePhotoSingleStaff = () => {
    Axios.delete(
      `${context.api_endpoint}/company/staff/delete/${params.id}/photo`
    )
      .then((response) => {
        if (response.status === 200) {
          toast.success(context.t(`profile.photoDeleteToast`));
          getSingleStaff();
        }
      })
      .catch((e) => {
        try {
          const errorMessage = e?.response?.data?.data
            || e?.response?.data?.message
            || e?.message
            || "Fotoğraf silinirken bir hata oluştu";
          toast.error(errorMessage);
        } catch (error) {
          console.error("Toast error:", error);
          toast.error("Bir hata oluştu");
        }
      });
  };

  const handleCategoryClick = (category, open_category) => {
    setCategoryId(category);
    setCategoryOpen([
      ...categoryOpen.map((c) => {
        return {
          ...c,
          id: category,
          open: open_category,
        };
      }),
    ]);
  };

  const selectAllCategoryServices = (categoryId) => {
    const categoryServices = categories.find(cat => cat.id === categoryId)?.services || [];
    const serviceIds = categoryServices.map(service => service.id);

    // Mevcut seçili servisler
    const currentServiceIds = [...employee.service_ids];

    // Kategorideki tüm servisleri ekle (zaten seçili olanları dahil etme)
    const newServiceIds = serviceIds.filter(id => !currentServiceIds?.includes(id));

    // Yeni service_ids listesi oluştur
    setEmployee({
      ...employee,
      service_ids: [...currentServiceIds, ...newServiceIds]
    });
  };

  const testFunck = () => {
    setEmployee({
      ...employee,
      package_ids: context.state.employeePackages,
    });
  };
  const updateSingleStaff = () => {
    testFunck();
    validateStaff() &&
      Axios.put(`${context.api_endpoint}/company/staff/update/${params.id}`, {
        ...employee,
        national_id: employee.national_id ? parseInt(employee.national_id, 10) : undefined,
        company_services: undefined,
        detail: {
          ...employee.detail,
          national_id: undefined,
          // birthday: employee.detail.format_birthday ?? null,
        },
        packet_ids: packets,
      })
        .then((response) => {
          if (response.status === 201) {
            setSelectedAgainServiceList(response.data.data.map((m) => m));
            setEmployee({
              ...employee,
              service_ids: [
                ...employee.service_ids,
                ...response.data.data.map((m) => m.id),
              ],
            });
            setSelectedAgainServiceModal(true);
          } else if (response.status === 200) {
            toast.success(context.t(`profile.updateToast`));
            history.push({
              pathname: "/settings",
              data: 2,
            });
          } else {
            toast.error("Something went wrong!");
          }
        })

        .catch((e) => {
          try {
            const respData = e?.response?.data;
            const errorMessage =
              (typeof respData === "string" ? respData : null)
              || respData?.data
              || respData?.message
              || e?.message
              || "Personel güncellenirken bir hata oluştu";
            toast.warning(errorMessage);
          } catch (error) {
            toast.error("Bir hata oluştu");
          }
        });
  };

  const deleteSingleStaff = (force = false) => {
    Axios.delete(
      `${context.api_endpoint}/company/staff/delete/${params.id}`,
      force ? { data: { force: true } } : undefined
    )
      .then((response) => {
        if (response.status === 200) {
          toast.success(context.t(`profile.deleteToast`));
          history.push("/settings/employees");
        }
      })
      .catch((e) => {
        try {
          const errorMessage =
            e?.response?.data?.data ||
            e?.response?.data?.message ||
            e?.message ||
            "Personel silinirken bir hata oluştu";

          if (!force) {
            setForceDeleteMessage(
              typeof errorMessage === "string"
                ? errorMessage
                : "Personel silinirken bir hata oluştu"
            );
            setForceDeleteConfirm(true);
            return;
          }

          toast.error(
            typeof errorMessage === "string"
              ? errorMessage
              : "Personel silinirken bir hata oluştu",
            {
              autoClose: 10000,
            }
          );
        } catch (error) {
          console.error("Toast error:", error);
          toast.error("Bir hata oluştu", {
            autoClose: 10000,
          });
        }
      });
  };

  const handleChange = (event, label) => {
    setEmployee({
      ...employee,
      limited_perm: {
        ...employee.limited_perm,
        [label]: parseInt(event.target.value),
      },
    });
  };

  const getServices = () => {
    Axios.get(
      `${context.api_endpoint}/company/services/with/category/all`
    ).then(async ({ data }) => {
      setCategories([...data.data.filter((m) => m.services.length !== 0)]);
    });
  };

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const changeHourStatus = (hour) => {
    !employee.closed_appointments[selectedDay]?.hours?.includes(hour)
      ? setEmployee({
        ...employee,
        closed_appointments: {
          ...employee.closed_appointments,
          [selectedDay]: {
            ...employee.closed_appointments[selectedDay],
            hours: [...employee.closed_appointments[selectedDay].hours, hour],
          },
        },
      })
      : setEmployee({
        ...employee,
        closed_appointments: {
          ...employee.closed_appointments,
          [selectedDay]: {
            ...employee.closed_appointments[selectedDay],
            hours: [
              ...employee.closed_appointments[selectedDay].hours.filter(
                (item) => item !== hour
              ),
            ],
          },
        },
      });
  };

  const changeDayStatus = () => {
    setEmployee({
      ...employee,
      closed_appointments: {
        ...employee.closed_appointments,
        [selectedDay]: {
          ...employee.closed_appointments[selectedDay],
          active: !employee.closed_appointments[selectedDay].active,
        },
      },
    });
  };

  const changeServiceStatus = (service_id) => {
    employee.service_ids?.includes(service_id)
      ? setEmployee({
        ...employee,
        service_ids: employee.service_ids.filter(
          (s_id) => service_id !== s_id
        ),
      })
      : setEmployee({
        ...employee,
        service_ids: [...employee.service_ids, service_id],
      });
  };

  const getInitials = (name) => {
    if (!name) return "??";
    const words = name.split(" ");
    if (words.length >= 2) {
      return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const validateStaff = () => {
    return Validate([
      {
        field: "İsim",
        value: employee.name,
        condition: /[a-zA-Z0-9ğüşöçİĞÜŞÖÇ]+/,
      },
      {
        field: "Soyisim",
        value: employee.surname,
        condition: /[a-zA-Z0-9ğüşöçİĞÜŞÖÇ]+/,
      },
      {
        field: "Cinsiyet",
        value: employee.sex,
        condition: Number,
      },
      {
        field: "Cep Telefonu",
        value: employee.detail.phone,
        condition: /\S{10}/,
      },
      {
        field: "E-Posta Adresi",
        value: employee.detail.mail,
        condition: /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/,
      },
    ]);
  };

  useEffect(() => {
    getSingleStaff();
    getServices();
    getRequiredArraysForStaffInsert();
  }, []);

  return (
    <AuthContainer>
      <Grid>
        <Column
          className="xs-12 mb-3"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
          }}
        >
          {loaded ? (
            employee.detail.profile_photo ? (
              <ProfilePhoto
                src={`${context.api_endpoint.replace("api/v1", "")}${context.state.company_id}/${employee.detail.profile_photo}`}
              />
            ) : (
              <InitialsCircle sex={employee.sex}>
                <InitialsText>{getInitials(employee.full_name)}</InitialsText>
              </InitialsCircle>
            )
          ) : (
            <div
              style={{ width: 160, height: 160, borderRadius: 5 }}
              className="skeleton"
            />
          )}
          <input
            id="profile_photo"
            style={{ display: "none" }}
            type="file"
            accept="image/*"
            onChange={(e) => uploadPhotoSingleStaff(e)}
          />

          <Button
            className="mt-1"
            icon="add_photo_alternate"
            title={context.t(`profile.photo.uploadButtonTitle`)}
            textColor="blue"
            backgroundColor="blue-opacity"
            fullWidth
            onClick={() => document.getElementById("profile_photo").click()}
          />
          {employee.detail.profile_photo && (
            <Button
              className="mt-1"
              icon="delete"
              title={context.t(`profile.photo.deleteButtonTitle`)}
              textColor="red"
              backgroundColor="red-opacity"
              fullWidth
              onClick={() => deletePhotoSingleStaff()}
            />
          )}
          {process.env.APP_NAME !== "management" && (
            <Button
              className="mt-1"
              icon="receipt"
              title={context.t(`employees.routeToStaffLogs`)}
              fullWidth
              onClick={() => {
                context.dispatch({
                  type: "LOG_TYPE",
                  payload: { log_type: 3 },
                });
                context.dispatch({
                  type: "LOG_ID",
                  payload: {
                    log_id: Number(employee.id),
                  },
                });
                history.push("/settings/logs");
              }}
            />
          )}
        </Column>

        <Column className="col-auto xs-12 sm-12 md-12 lg-12 xl-12">
          <CardSection title={context.t(`profile.detail.title`)}>
            {/* Name, Surname, Gender */}
            <Column className="xs-12 sm-12 md-4">
              <Input
                required
                label={context.t(`profile.detail.nameInputLabel`)}
                value={employee.name !== null ? employee.name : ""}
                onChange={(e) => {
                  setEmployee({
                    ...employee,
                    name: e.target.value,
                  });
                }}
              />
            </Column>
            <Column className="xs-12 sm-12 md-4">
              <Input
                required
                label={context.t(`profile.detail.surnameInputLabel`)}
                value={employee.surname !== null ? employee.surname : ""}
                onChange={(e) => {
                  setEmployee({
                    ...employee,
                    surname: e.target.value,
                  });
                }}
              />
            </Column>
            <Column className="xs-12 sm-12 md-2">
              <CSwitch
                title={context.t(`customers.headings.sex`)}
                label={context.t(`profile.detail.genderMale`)}
                labelLeft={context.t(`profile.detail.genderFemale`)}
                checked={!!employee.sex}
                color="primary"
                closeColor="purple"
                onChange={(checked) => {
                  setEmployee({
                    ...employee,
                    sex: checked.target.checked === false ? 0 : 1,
                  });
                }}
              />
              {/* <Select
                  required
                  label={context.t(`profile.detail.genderInputLabel`)}
                  items={[
                    {
                      value: "0",
                      name: context.t(`profile.detail.genderFemale`),
                    },
                    {
                      value: "1",
                      name: context.t(`profile.detail.genderMale`),
                    },
                  ]}
                  selected={employee.sex !== null ? `${employee.sex}` : ""}
                  labelKey="name"
                  valueKey="value"
                  handler={(sex) =>
                    setState({
                      employee: {
                        ...employee,
                        sex: parseInt(sex),
                      },
                    })
                  }
                /> */}
            </Column>
            <Column className="xs-12 sm-12 md-2">
              <h3>{context.t(`customers.headings.colorSelect`)}</h3>
              <div>
                <div className="swatch" onClick={handleClick}>
                  <div
                    className="color"
                    style={{ background: employee.color }}
                  />
                </div>
                {displayColorPicker ? (
                  <div className="popover">
                    <div className="cover" onClick={handleClose} />
                    <ChromePicker
                      color={employee.color}
                      onChangeComplete={(color) => {
                        setEmployee({
                          ...employee,
                          color: color.hex,
                        });
                      }}
                    />
                  </div>
                ) : null}
              </div>
            </Column>

            {/* Birthday? , Job Title , Percentage of Fixed Bonus  */}
            {/* <Column className="xs-12 sm-12 md-4">
                <DatePickerInput
                  className="mb-0"
                  label={context.t(`profile.detail.birthdayInputLabel`)}
                  value={state.employee.detail.format_birthday ?? null}
                  onChange={async (selected_date) => {
                    setState({
                      employee: {
                        ...state.employee,
                        detail: {
                          ...state.employee.detail,
                          birthday: moment(selected_date).format("DD/MM/YYYY"),
                          format_birthday: selected_date,
                        },
                      },
                    });
                  }}
                />
              </Column> */}
            <Column className="xs-12 sm-12 md-4">
              <Input
                label={context.t(`profile.detail.jobTitleInputLabel`)}
                value={
                  employee.detail.job_title !== null
                    ? employee.detail.job_title
                    : ""
                }
                onChange={(e) => {
                  setEmployee({
                    ...employee,
                    detail: {
                      ...employee.detail,
                      job_title: e.target.value,
                    },
                  });
                }}
              />
            </Column>
            {(context.current_flag & context.state.FLAGS.SALON_RANDEVU && (
              <Column className="xs-12 sm-12 md-4">
                <MaskedInput
                  label={context.t(`profile.detail.bountyInputLabel`)}
                  mask="99"
                  maskChar=""
                  value={
                    employee.detail.bounty !== null
                      ? employee.detail.bounty
                      : ""
                  }
                  onChange={(e) => {
                    setEmployee({
                      ...employee,
                      detail: {
                        ...employee.detail,
                        bounty:
                          e.target.value.length > 0
                            ? parseInt(e.target.value)
                            : null,
                      },
                    });
                  }}
                />
              </Column>
            )) ||
              null}
            <Column className="xs-12 sm-12 md-4">
              <MaskedInput
                label="Kimlik No (TC)"
                mask="99999999999"
                maskChar=""
                value={employee.national_id ?? ""}
                disabled={originalNationalId !== null && originalNationalId !== ""}
                onChange={(e) => {
                  setEmployee({
                    ...employee,
                    national_id: e.target.value.replace(/\s/g, "") || null,
                  });
                }}
              />
            </Column>

            {/* Panel Authorization, Email Sending, Display Enterprise Url*/}
            <Column
              className={
                (context.current_flag & context.state.FLAGS.SALON_RANDEVU &&
                  "xs-12 sm-12 md-4") ||
                "xs-12 sm-12 md-6"
              }
            >
              <Select
                required
                disabled={
                  context.state.user.id === parseInt(params.id) ||
                  context.state.user.permission === 2
                }
                label={context.t(`profile.detail.permissionInputLabel`)}
                items={
                  context.state.user.id != parseInt(params.id) &&
                    context.state.user.permission === 2 &&
                    context.state.limited_permission.system == 1
                    ? [{ value: 0, name: " " }]
                    : [
                      {
                        value: 0,
                        name: context.t(`profile.detail.permissionStaff`),
                      },
                      {
                        value: 1,
                        name: context.t(`profile.detail.permissionOwner`),
                      },
                      {
                        value: 2,
                        name: context.t(`profile.detail.permissionLimited`),
                      },
                    ]
                }
                selected={
                  employee.permission !== null ? `${employee.permission}` : ""
                }
                labelKey="name"
                valueKey="value"
                handler={(permission) => {
                  setEmployee({
                    ...employee,
                    permission: parseInt(permission),
                  });
                }}
              />
            </Column>
            <Column
              className={
                (context.current_flag & context.state.FLAGS.SALON_RANDEVU &&
                  "xs-12 sm-12 md-4") ||
                "xs-12 sm-12 md-6"
              }
            >
              <Select
                required
                label={context.t(`profile.detail.sendSmsInputLabel`)}
                items={[
                  {
                    value: true,
                    label: context.t(`profile.detail.sendSmsTrue`),
                  },
                  {
                    value: false,
                    label: context.t(`profile.detail.sendSmsFalse`),
                  },
                ]}
                selected={
                  employee.send_sms !== null ? `${employee.send_sms}` : ""
                }
                labelKey="label"
                valueKey="value"
                handler={(send_sms) => {
                  setEmployee({
                    ...employee,
                    send_sms: send_sms === "true",
                  });
                }}
              />
            </Column>
            <Column
              className={
                (context.current_flag & context.state.FLAGS.SALON_RANDEVU &&
                  "xs-12 sm-12 md-4") ||
                "xs-12 sm-12 md-6"
              }
            >
              <Select
                required
                label={context.t(`profile.detail.urlInputLabel`)}
                items={[
                  {
                    value: true,
                    label: context.t(`profile.detail.showAtUrlTrue`),
                  },
                  {
                    value: false,
                    label: context.t(`profile.detail.showAtUrlFalse`),
                  },
                ]}
                selected={
                  employee.show_at_url !== null ? `${employee.show_at_url}` : ""
                }
                labelKey="label"
                valueKey="value"
                handler={(show_at_url) => {
                  setEmployee({
                    ...employee,
                    show_at_url: show_at_url === "true",
                  });
                }}
              />
            </Column>

            {/* Form Section Settings Limited Permission  */}
            {employee.permission === 2 &&
              context.state.user.permission === 1 && (
                <Column className="xs-12 sm-12 md-12">
                  <div className="authoritySettings">
                    {limitedPermission.map((permission, index) => (
                      <div key={permission.name} className="authoritySection">
                        <div className="authorityForm">
                          <FormControl component="fieldset">
                            <FormLabel
                              className="authorityLabel"
                              component="legend"
                            >
                              {permission.label}
                            </FormLabel>
                            <RadioGroup
                              row
                              aria-label="gender"
                              name={permission.name}
                              value={
                                employee.limited_perm[`${permission.name}`]
                              }
                              onChange={(event) => {
                                handleChange(event, permission.name);
                              }}
                            >
                              {permission.name === "appointment_visibility" ? (
                                <div style={{ position: 'relative' }}>
                                  <span
                                    className="bg-orange"
                                    style={{
                                      position: 'absolute',
                                      top: "-37px",
                                      right: "-58px",
                                      zIndex: "11",
                                      color: 'white',
                                      padding: '2px 7px',
                                      borderRadius: '12px',
                                      fontSize: '10px',
                                      fontWeight: 'bold',
                                      textTransform: 'uppercase'
                                    }}
                                  >
                                    {context.t(`appointments.detail.statusNew`)}
                                  </span>
                                  <FormControlLabel
                                    value={1}
                                    control={<Radio size="small" />}
                                    label={context.t(
                                      `profile.limited_permission_label.all`
                                    )}
                                  />
                                  <FormControlLabel
                                    value={0}
                                    control={<Radio size="small" />}
                                    label={context.t(
                                      `profile.limited_permission_label.just_itself`
                                    )}
                                  />
                                </div>

                              ) : (<>
                                <FormControlLabel
                                  value={0}
                                  control={<Radio size="small" />}
                                  label={context.t(
                                    `profile.limited_permission_label.no_permission`
                                  )}
                                />
                                <FormControlLabel
                                  value={1}
                                  control={<Radio size="small" />}
                                  label={context.t(
                                    `profile.limited_permission_label.display`
                                  )}
                                />
                                <FormControlLabel
                                  value={2}
                                  control={<Radio size="small" />}
                                  label={context.t(
                                    `profile.limited_permission_label.full_permission`
                                  )}
                                />
                              </>)}
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    ))}
                  </div>
                </Column>
              )}
          </CardSection>

          <CardSection
            title={context.t(`profile.contact.title`)}
            className="mt-5"
          >
            <Column className="xs-12 sm-12 md-4">
              <Input
                required
                label={context.t(`profile.contact.mailInputLabel`)}
                value={
                  employee.detail.mail !== null ? employee.detail.mail : ""
                }
                onChange={(e) => {
                  setEmployee({
                    ...employee,
                    detail: {
                      ...employee.detail,
                      mail: e.target.value,
                    },
                  });
                }}
              />
            </Column>

            <Column className="xs-12 sm-12 md-4">
              <MaskedInput
                required
                label={context.t(`profile.contact.phoneInputLabel`)}
                placeholder="500 000 0000"
                mask="999 999 9999"
                maskChar=""
                value={
                  employee.detail.phone !== null ? employee.detail.phone : ""
                }
                startAdornment="+90"
                onChange={(e) => {
                  setEmployee({
                    ...employee,
                    detail: {
                      ...employee.detail,
                      phone:
                        e.target.value && e.target.value.substring(0, 1) === "5"
                          ? e.target.value.replace(/\s/g, "")
                          : null,
                    },
                  });
                }}
              />
            </Column>

            <Column className="xs-12 sm-12 md-4">
              <Input
                label={context.t(`profile.contact.newPasswordInputLabel`)}
                autoComplete={false}
                type="password"
                onChange={(e) => {
                  setEmployee({
                    ...employee,
                    password: e.target.value,
                  });
                }}
              />
            </Column>
          </CardSection>

          <CardSection
            title={context.t(`profile.services.title`)}
            className="mt-5"
          >
            <Column className="xs-12 sm-12 mb-3">
              <Alert severity="info">
                <b>{context.t(`profile.services.alertBoldText`)}</b>
                <br />
                {context.t(`profile.services.alertText`)}
              </Alert>
            </Column>
            <Column className="xs-12 sm-12">
              <Grid>
                {loaded === true &&
                  categories.map((category, index) => {
                    return (
                      <Column
                        key={index}
                        className="col xs-12 sm-12 md-12 lg-12 xl-12"
                      >
                        <div className="category-container_divider" style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          borderBottom: '1px solid #eee',
                          padding: '10px 0',
                          marginBottom: '15px'
                        }}>
                          <div
                            onClick={() => {
                              handleCategoryClick(category.id, true);
                            }}
                            className="category-container"
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              fontWeight: 'bold',
                              fontSize: '15px',
                              cursor: 'pointer',
                              flex: 1
                            }}
                          >
                            <span>{category.name}</span>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <SelectAllButton
                              onClick={(e) => {
                                e.stopPropagation();
                                selectAllCategoryServices(category.id);
                              }}
                            >
                              {context.t(`profile.services.selectAll`) || "Tümünü Seç"}
                            </SelectAllButton>
                            <span
                              className="category-container_span"
                              onClick={() => {
                                handleCategoryClick(category.id, false);
                              }}
                              style={{
                                color: '#666',
                                cursor: 'pointer'
                              }}
                            >
                              <CloseOutlined />
                            </span>
                          </div>
                        </div>
                        {category.services.map((service) => {
                          return (
                            <>
                              {categoryOpen.map((category_open, index) => {
                                if (
                                  category_open.id === category.id &&
                                  category_open.open === true
                                ) {
                                  return (
                                    <Column className="col xs-12 sm-12 md-6 lg-6 xl-6">
                                      <div
                                        key={index}
                                        style={{
                                          cursor: "pointer",
                                          border: `1px solid ${employee.service_ids?.includes(
                                            service.id
                                          )
                                            ? "#3189ec"
                                            : "white"
                                            }`,
                                          borderRadius: "5px",
                                          marginBottom: "12px",
                                          padding: "10px 0px",
                                          width: "100%",
                                          color: `${employee.service_ids?.includes(
                                            service.id
                                          )
                                            ? "#3189ec"
                                            : "black"
                                            }`,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                        onClick={() =>
                                          changeServiceStatus(service.id)
                                        }
                                      >
                                        {employee.service_ids?.includes(
                                          service.id
                                        ) ? (
                                          <CheckIcon
                                            fontSize="small"
                                            style={{ paddingRight: "5px" }}
                                          />
                                        ) : (
                                          <CloseIcon
                                            fontSize="small"
                                            style={{ paddingRight: "5px" }}
                                          />
                                        )}
                                        {service.name}
                                      </div>
                                    </Column>
                                  );
                                }
                              })}
                            </>
                          );
                        })}
                      </Column>
                    );
                  })}
              </Grid>
            </Column>
          </CardSection>
          <CardSection title={context.t(`employees.packagesTitle`)} className="mt-5">
            <Column className="xs-12 sm-12 mb-3">
              <Alert severity="info">
                <b>{context.t(`profile.packages.alertBoldText`)}</b>
                <br />
                {context.t(`profile.packages.alertText`)}
              </Alert>
            </Column>
            <EmpoolesPackages packets={packets} updateState={updateState} />
          </CardSection>
          <CardSection
            title={context.t(`profile.booking.title`)}
            className="mt-5"
          >
            <Column className="xs-12 sm-12">
              <DayTabContainer>
                {context.t(`profile.booking.week`)?.map((item, index) => (
                  <ButtonBase key={index}>
                    <StyledDayTab
                      key={index}
                      className="ripple"
                      day={index + 1}
                      selected_day={selectedDay}
                      onClick={() => {
                        setSelectedDay(index + 1);
                      }}
                      children={item}
                    />
                  </ButtonBase>
                ))}
              </DayTabContainer>
              {loaded === true ? (
                <FormControlLabel
                  className="mb-2"
                  control={
                    <Switch
                      color="primary"
                      checked={employee.closed_appointments[selectedDay].active}
                      onChange={() => changeDayStatus(selectedDay)}
                    />
                  }
                  label={
                    <FCLabel>
                      {employee.closed_appointments[selectedDay].active === true
                        ? context.t(`profile.booking.dayCloseText`)
                        : context.t(`profile.booking.dayOpenText`)}
                    </FCLabel>
                  }
                />
              ) : (
                <div
                  style={{
                    width: 283,
                    maxWidth: "100%",
                    height: 33,
                    borderRadius: 5,
                  }}
                  className="skeleton mb-2 ml-1"
                />
              )}
            </Column>
            <Column className="xs-12 sm-12">
              {parseInt(context.state.company_shift.slice) > 0 ? (
                generatedHours.map((hour, index) => (
                  <div
                    key={index}
                    className="col xs-6 sm-2 md-2 lg-2 xl-2 mb-2 p-horizontal-1"
                  >
                    <Button
                      disabled={
                        !employee.closed_appointments[selectedDay].active
                      }
                      key={index}
                      fullWidth={true}
                      className={
                        employee.closed_appointments[selectedDay].active &&
                          !employee.closed_appointments[
                            selectedDay
                          ].hours?.includes(hour)
                          ? `elevation-2`
                          : ""
                      }
                      onClick={() => changeHourStatus(hour)}
                      icon={
                        employee.closed_appointments[selectedDay].active &&
                          !employee.closed_appointments[
                            selectedDay
                          ].hours?.includes(hour)
                          ? "check"
                          : "close"
                      }
                      title={hour}
                      //outlined={employee.appointments[selected_day].active && !employee.appointments[selected_day].hours.includes(hour)}
                      backgroundColor={"white"}
                      textColor={
                        employee.closed_appointments[selectedDay].active &&
                          !employee.closed_appointments[
                            selectedDay
                          ].hours?.includes(hour)
                          ? "green"
                          : "red"
                      }
                    />
                  </div>
                ))
              ) : (
                <Alert severity="info">
                  <b>{context.t(`profile.booking.alertBoldText`)}</b>
                </Alert>
              )}
            </Column>
          </CardSection>

          <Button
            className="mt-3 mb-1"
            icon="update"
            title={context.t(`profile.updateButtonTitle`)}
            backgroundColor="primary"
            textColor="white"
            fullWidth={true}
            onClick={() => updateSingleStaff()}
          />

          <Button
            disabled={parseInt(params.id) === context.state.user.id}
            icon="delete_forever"
            title={context.t(`profile.deleteButtonTitle`)}
            backgroundColor="red-opacity"
            textColor="red"
            fullWidth={true}
            onClick={() => setDeleteConfirm(true)}
          />
          <ModalDialog
            open={deleteConfirm}
            closeHandler={() => setDeleteConfirm(false)}
            title={context.t(`profile.delete.title`)}
            maxWidth="sm"
            fullWidth={true}
            buttons={[
              {
                title: context.t(`profile.delete.confirmButtonTitle`),
                icon: "check",
                timer: 10,
                backgroundColor: "red",
                textColor: "white",
                onClick: () => deleteSingleStaff(),
              },
              {
                title: context.t(`profile.delete.discardButtonTitle`),
                icon: "close",
                backgroundColor: "grey-light",
                textColor: "grey",
              },
            ]}
          >
            <div style={{
              padding: "16px 8px",
              lineHeight: "1.6",
              fontSize: "15px",
              color: "#333"
            }}>
              <div style={{
                marginBottom: "20px",
                padding: "16px 20px",
                backgroundColor: "#fef3f2",
                borderLeft: "4px solid #f87171",
                borderRadius: "6px"
              }}>
                {context.t(`profile.delete.deleteItems`).map((item, index) => (
                  <div key={index} style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: index === 3 ? "0" : "8px",
                    fontSize: "15px",
                    color: "#374151"
                  }}>
                    <span style={{
                      color: "#ef4444",
                      marginRight: "10px",
                      fontSize: "14px"
                    }}>●</span>
                    <span style={{
                      fontWeight: index === 2 ? "600" : "normal",
                      color: index === 2 ? "#dc2626" : "#374151"
                    }}>
                      {item}
                    </span>
                  </div>
                ))}
              </div>

              <div style={{
                marginBottom: "16px",
                fontSize: "15px",
                color: "#374151",
                fontWeight: "500"
              }}>
                {context.t(`profile.delete.warningText`)}
              </div>

              <div style={{
                marginBottom: "20px",
                padding: "16px 20px",
                backgroundColor: "#fef2f2",
                border: "1px solid #fecaca",
                borderRadius: "8px",
                fontSize: "15px",
                fontWeight: "600",
                color: "#dc2626",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 4px rgba(220, 38, 38, 0.1)"
              }}>
                <span style={{
                  fontSize: "18px",
                  marginRight: "8px",
                  display: "inline-block"
                }}><WarningIcon /></span>
                <span>{context.t(`profile.delete.finalWarning`)}</span>
              </div>

              <div style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#dc2626",
                textAlign: "center",
                padding: "12px 0"
              }}>
                {context.t(`profile.delete.confirmQuestion`)}
              </div>
            </div>
          </ModalDialog>
          <ModalDialog
            open={forceDeleteConfirm}
            closeHandler={() => {
              setForceDeleteConfirm(false);
              setForceDeleteMessage("");
            }}
            title={context.t(`profile.delete.forceDelete.title`)}
            maxWidth="sm"
            fullWidth={true}
            buttons={[
              {
                title: context.t(`profile.delete.forceDelete.confirmButtonTitle`),
                icon: "delete_forever",
                backgroundColor: "red",
                textColor: "white",
                onClick: () => deleteSingleStaff(true),
              },
              {
                title: context.t(`profile.delete.forceDelete.discardButtonTitle`),
                icon: "close",
                backgroundColor: "grey-light",
                textColor: "grey",
              },
            ]}
          >
            <Alert severity="warning">
              <b>{context.t(`profile.delete.forceDelete.alertBoldText`)}</b>
              <br />
              {forceDeleteMessage ||
                context.t(`profile.delete.forceDelete.alertText`)}
            </Alert>
          </ModalDialog>
          <ModalDialog
            open={selectedAgainServiceModal}
            closeHandler={() => {
              setSelectedAgainServiceModal(false);
            }}
            buttons={[
              {
                title: context.t(`employees.addAllService`),
                icon: "check",

                backgroundColor: "primary-opacity",
                textColor: "primary",
                onClick: () => {
                  setEmployee({
                    ...employee,
                    service_ids: [
                      ...employee.service_ids,
                      ...selectedAgainServiceList.map((m) => m.id),
                    ],
                  });
                  updateSingleStaff();
                },
              },
              {
                title: context.t(`["accounting/bounty"].check.discardButtonTitle`),
                icon: "close",
                textColor: "grey",
                onClick: () => {
                  setEmployee({
                    ...employee,
                    service_ids: lastServicesIds,
                  });
                },
              },
            ]}
          >
            <Alert severity="warning">
              {context.t(`employees.addAllServiceWarn`)}
            </Alert>
            <div style={{ width: "100%" }}>
              {selectedAgainServiceList.map((m) => (
                <div style={{ width: "100%" }}>-{m.name} </div>
              ))}
            </div>
          </ModalDialog>
        </Column>
      </Grid>
    </AuthContainer>
  );
};

export default SingleEmployee;

const StyledDayTab = styled.div`
  width: auto;
  flex: none;
  text-align: center;
  font-size: 14px;
  padding: 16px;
  font-weight: 500;
  color: ${({ day, selected_day }) =>
    day === selected_day ? "var(--primary)" : "var(--black)"};
  border-bottom: 2px solid
    ${({ day, selected_day }) =>
    day === selected_day ? "var(--primary)" : "var(--white)"};
  box-sizing: border-box;
  cursor: pointer;
`;

const DayTabContainer = styled.div`
  width: -webkit-fill-available;
  position: relative;
  z-index: 100;
  margin: 0;
  padding: 0;
  overflow-x: auto;
  overflow-y: hidden !important;
  list-style: none;
  display: inline-flex;
  margin-bottom: 16px;
  box-sizing: content-box;

  button {
    font-family: "Inter", sans-serif !important;
  }
`;

const ProfilePhoto = styled.img`
  background: #fafafa;
  width: 160px;
  height: 160px;
  max-width: 100%;
  object-fit: cover;
  border-radius: 5px;
`;

const InitialsCircle = styled.div`
  width: 160px;
  height: 160px;
  border-radius: 5px;
  background: ${props =>
    props.sex === 0
      ? 'linear-gradient(135deg, #FF639A 0%, #FF9CB7 50%, #FF9CB7 100%)' // Kadın - pembe gradient
      : props.sex === 1
        ? 'linear-gradient(135deg, #8BD6F7 0%, #0060EE 100%)' // Erkek - mavi gradient
        : 'linear-gradient(135deg, #8BD6F7 0%, #0060EE 100%)' // Varsayılan - mavi gradient
  };
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

const InitialsText = styled.span`
  color: white;
  font-size: 48px;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
`;